import { defineStore } from 'pinia';
import api from '../api';
import { v4 as uuidv4 } from 'uuid';

export const useCartStore = defineStore('cart', {
    state: () => ({
        items: [],
        subtotal: 0,
        shippingFee: 0,
        totalAmount: 0,
        loading: false,
        error: null,
    }),
    getters: {
        itemCount: (state) => state.items.reduce((total, item) => total + item.quantity, 0),
    },
    actions: {
        initializeSession() {
            let sessionId = localStorage.getItem('session_id');
            if (!sessionId) {
                sessionId = uuidv4();
                localStorage.setItem('session_id', sessionId);
            }
        },
        
        async fetchCart() {
            this.loading = true;
            this.initializeSession();
            try {
                const response = await api.get('/cart');
                const data = response.data.data;
                this.items = data.items;
                this.subtotal = parseFloat(data.summary?.subtotal || 0);
                this.shippingFee = parseFloat(data.summary?.shipping || 0);
                this.totalAmount = parseFloat(data.summary?.total || 0);
            } catch (err) {
                this.error = err.message;
            } finally {
                this.loading = false;
            }
        },

        async addToCart(productId, variantId, quantity) {
            this.loading = true;
            this.initializeSession();
            try {
                await api.post('/cart', {
                    product_id: productId,
                    variant_id: variantId,
                    quantity: quantity
                });
                await this.fetchCart();
            } catch (err) {
                throw err; // Propagate error to component
            } finally {
                this.loading = false;
            }
        },

        async updateQuantity(itemId, quantity) {
            this.loading = true;
            try {
                await api.put(`/cart/${itemId}`, { quantity });
                await this.fetchCart();
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
            }
        },

        async removeItem(itemId) {
            this.loading = true;
            try {
                await api.delete(`/cart/${itemId}`);
                await this.fetchCart();
            } catch (err) {
                throw err;
            } finally {
                this.loading = false;
            }
        }
    }
});
